export var ScoutErrorCode = /*#__PURE__*/ function(ScoutErrorCode) {
    ScoutErrorCode["Forbidden"] = "forbidden";
    ScoutErrorCode["ClientNotFound"] = "CLIENT_NOT_FOUND";
    return ScoutErrorCode;
}({});
